import { Input } from "@/shared/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/shared/components/ui/table";
import { cn } from "@/shared/libs/utils";
import type { ChannelDelayThresholdRow } from "../types/preferences_types";

export function ChannelDelayThresholdTable({
    rows,
    onChange,
    disabled = false,
}: {
    rows: ChannelDelayThresholdRow[];
    onChange: (index: number, patch: Partial<Pick<ChannelDelayThresholdRow, "hours" | "minutes">>) => void;
    disabled?: boolean;
}) {
    return (
        <div className="max-w-[1000px] mx-auto rounded-md border overflow-x-auto">
            <Table className="min-w-[760px]">
                <TableHeader>
                    <TableRow>
                        <TableHead className="w-[30%] text-center">채널</TableHead>
                        <TableHead className="w-[30%] text-center">서브 채널</TableHead>
                        <TableHead className="w-[20%] text-center">시간</TableHead>
                        <TableHead className="w-[20%] text-center">분</TableHead>
                    </TableRow>
                </TableHeader>

                <TableBody>
                    {rows.map((r, idx) => {
                        const isTop = !r.subChannel;
                        return (
                            <TableRow key={`${r.channel}:${r.subChannel ?? "-"}`}>
                                <TableCell className={cn("text-center", isTop && "font-semibold")}>{r.channel}</TableCell>
                                <TableCell className="text-center">{r.subChannel ? r.subChannel : "-"}</TableCell>

                                <TableCell className="text-center">
                                    <div className="flex items-center justify-center gap-2">
                                        <Input
                                            value={r.hours}
                                            disabled={disabled}
                                            onChange={(e) => onChange(idx, { hours: e.target.value })}
                                            className="h-9 w-[90px] text-center"
                                        />
                                        <span className="text-sm text-muted-foreground">시간</span>
                                    </div>
                                </TableCell>

                                <TableCell className="text-center">
                                    <div className="flex items-center justify-center gap-2">
                                        <Input
                                            value={r.minutes}
                                            disabled={disabled}
                                            onChange={(e) => onChange(idx, { minutes: e.target.value })}
                                            className="h-9 w-[90px] text-center"
                                        />
                                        <span className="text-sm text-muted-foreground">분</span>
                                    </div>
                                </TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </div>
    );
}